import { Pipe, PipeTransform } from '@angular/core';
import { TaskHistory } from '@workspaces/models/task';

@Pipe({
  name: 'taskHistoryDisplay',
  standalone: true
})
export class TaskHistoryDisplayPipe implements PipeTransform {
  transform(item: TaskHistory): string {
    switch (item.change_type) {
      case 'created':
        return `created this task.`;

      case 'status_changed':
        return `changed status from '${item.changes['status'].old
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')}' to '${item.changes['status'].new
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')}'.`;

      case 'renamed': {
        const titleChange = item.changes['title'] || item.changes['name'];
        return `renamed the task from '${titleChange.old}' to '${titleChange.new}'.`;
      }

      case 'description_changed':
        return `updated the description.`;

      case 'priority_changed': {
        const priorityChange = item.changes['priority'];
        return `changed priority from '${priorityChange.old
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')}' to '${priorityChange.new
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')}'.`;
      }

      case 'comment_added':
        return `added a new comment.`;

      case 'comment_updated':
        return `updated a comment.`;

      case 'comment_deleted':
        return `deleted a comment.`;

      case 'updated': {
        const keys = Object.keys(item.changes)
          .join(', ')
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
          .split('_')
          .join(' ');

        return `made general updates to the following fields: ${keys}.`;
      }

      default:
        return `made a change of type: ${item.change_type}.`;
    }
  }
}
